import { LinkButton } from '@fox/atoms/src/button/link-button';
import { Typography } from '@fox/atoms/src/typography';
import { QuestionStyleTypes } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../form-runtime-context/form-runtime-context';
import { QuestionDescriptionRender } from '../../question-block/question-description';
import { QuestionLabelWrapper } from '../shared-components/styled-components';

type NotYouLinkButtonProps = {
	id: string;
	firstName?: string;
	lastName?: string;
};

export const NotYouLinkButton = ({ id, firstName, lastName }: NotYouLinkButtonProps) => {
	const { setIgnoreCreatePersonBehaviour, setTarget } = useFormRuntimeContext();
	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, id);

	return (
		<div>
			{firstName && lastName ? (
				<>
					<QuestionLabelWrapper>
						<QuestionDescriptionRender id={id} value="Name" />
					</QuestionLabelWrapper>
					<Typography sx={{ fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight }}>
						{firstName} {lastName}
					</Typography>
				</>
			) : null}
			<LinkButton
				onClick={() => {
					setIgnoreCreatePersonBehaviour(true);
					setTarget(undefined);
				}}
			>
				Not you? Click here to add your details.
			</LinkButton>
		</div>
	);
};
